// import authReducer from './components/pages/auth/reducer';
import appReducer from './components/app/reducer';

export default ({ auth, app }, action) => ({
    // auth: authReducer(auth, action),
    app: appReducer(app, action)
});